export const ROLES = {
    NO_ROLE : 0,
    ROLE_PM : 1,
    ROLE_RM : 2,
    ROLE_BM : 3,
    ROLE_TM : 4,
    ROLE_OM : 5,
    ROLE_EMP: 7,
    ROLE_SITE_ADMIN : 8,
    ROLE_ADMIN : 9,
    ROLE_ESCORT : 10,
    ROLE_USERAUDITOR : 12,
    ROLE_VM : 13,
    ROLE_V_BILLING_MGR : 14,
    ROLE_SCHEDULE_MANAGER : 15,
    ROLE_BILLING_DATA_ENTRY : 16,
    ROLE_BILLING_DATA_ENTRY_SUPERVISOR : 17,
    ROLE_TRACKER : 18,
    ROLE_BILLING_AUDITOR : 19,
    ROLE_SYS_ADMIN : 20,
    ROLE_PLATFORM_V_BILLING_MGR : 21,
    ROLE_TRANSPORT_MANAGER_NO_BILLING : 22,
    ROLE_BILLING_MASTER : 23,
    ROLE_VENDOR_RISK_MANAGER : 24,
    ROLE_COMPLIANCE_MANAGER : 25,
    ROLE_SECURITY_SUPERVISOR : 26,
    ROLE_SPOT_BOOKING_MANAGER : 27,
    ROLE_EXECUTIVE_ASSISTANT : 28,
    ROLE_COMPLIANCE_AUDITOR : 29,
    ROLE_TRANSPORT_MANAGER_NO_COMPLIANCE : 31,
    ROLE_FINANCIAL_CONTROLLER : 32,
    ROLE_SENIOR_BILLING_AUDITOR : 33,
    ROLE_SYSTEM_AUDITOR : 34,
    ROLE_MIS_SUPPORT : 35,

}